// import useModal from '@src/utils/hooks/use-modal';
import { autobind } from 'core-decorators';
import useMount from '@src/utils/hooks/use-mount';
import { computed, observable } from 'mobx';
import { noop } from '@src/utils/common-util';
// import AntdMessage from '@src/components/antd/message';
import ZtServiceFactory from '@src/services/zt';
// import { aLink } from '@src/utils/common-util';
// import Video from '@src/components/yt-video-modal';
// import { getLocales } from '@src/global-locales/get-page-locales-data';
// import styles from './index.less';
import useModal from '@src/utils/hooks/use-modal';
import AppointmentModal from '@src/business-components/appointment-modal';
import AppointmentModalStore from '@src/business-components/appointment-modal/store';
import AppointmentSuccessModal from '@src/business-components/appointment-success-modal';
import AppointmentSuccessModalStore from '@src/business-components/appointment-success-modal/store';
import cmsApi from '@src/services/cms-api';
import { CMS_API_CONFIG_ROOT } from '@src/constants/urls';
import { useRequest } from 'ahooks';
import getLanguageFolderName from '@src/utils/locale/getLanguageFolderName';
import { aLink } from '@src/utils/common-util';
import { $$tracker } from '@src/tracker';
import NewsSwiperStore from '@src/business-components/news-swiper/store';
import VideoModalStore from '@src/business-components/video-modal/store';
import VideoModal from '@src/business-components/video-modal';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

class FirstSectionStore {
  /**
   * store中初始化service接口变量
   */
  $ztService = ZtServiceFactory.getDefaultInstance();

  // 预约弹窗
  // 预约弹窗
  appointmentModalStore = new AppointmentModalStore({
    appointmentSuccessCallBack: email => {
      // 下载阶段设置一个30分钟的缓存
      // console.log(this.downLoadBtnState);
      if (this.downLoadBtnState) {
        // 获取当前时间戳（单位：毫秒）
        const now = Date.now();
        const cacheKey = 'appointmentData'; // 缓存键名
        // 设置缓存有效期为30分钟（1800000毫秒）
        const cacheExpiration = 30 * 60 * 1000;
        // 保存数据到 localStorage，包含数据和时间戳
        const dataToCache = {
          value: 'true',
          timestamp: now
        };
        // 将数据保存到 localStorage
        localStorage.setItem(cacheKey, JSON.stringify(dataToCache));
        // 设置过期时间（30分钟）
        localStorage.setItem(`${cacheKey}_expiration`, now + cacheExpiration);
      }

      // console.log(email);
      this.appointmentSuccessModalStore.email = email;
      this.modals.AppointmentSuccess.open();
    }
  });

  appointmentSuccessModalStore = new AppointmentSuccessModalStore();
  videoModalStore = new VideoModalStore();

  // 是否激活
  @observable isActive = false;
  // 预约Email
  @observable Email = false;
  // 是否在下载游戏时间内
  @observable isDownLoadTime = 0;
  // 预约成功回调
  @observable appointmentSuccessCallBack = noop;
  // ytID
  @observable videoPvId = '';

  @observable steam_link = 'https://store.steampowered.com/app/2452280/Mecha_BREAK?utm_source=OFW&utm_campaign=open_beta_feb&utm_medium=DLC';

  @observable xbox_link = 'https://www.xbox.com/en-US/games/store/mecha-break/9n1bzs0v3k0c';

  @observable steam_link1;
  @observable xbox_link1;

  /**
   * 开启下载
   */
  @computed
  get downLoadBtnState() {
    return this.isDownLoadTime === 1;
  }
  /**
   * 是否已经预约/登录
   * @type {boolean}
   */
  @computed
  get hasLogin() {
    return !!this.Email;
  }

  /**
   * 是否显示视频模块
   * @returns {boolean}
   */
  @computed
  get showVideoPart() {
    return !!this.videoModalStore.videoUrl;
  }
 
  /**
   *
   * @type {NewsSwiperStore}
   */
  newsSwiperStore = new NewsSwiperStore();

  /**
   * 点击预约按钮
   */
  @autobind
  async onClickAppointment() {
    // this.modals.appointment.open();
    const cacheKey = 'appointmentData';
    const expirationKey = `${cacheKey}_expiration`;
    // 获取缓存数据和过期时间
    const cachedData = localStorage.getItem(cacheKey);
    const expirationTime = localStorage.getItem(expirationKey);
    const now = Date.now();
    if (cachedData && expirationTime && now < expirationTime) {
      // 如果缓存存在且未过期
      const data = JSON.parse(cachedData);
    } else {
      // 缓存过期或不存在
      localStorage.removeItem(cacheKey);
      localStorage.removeItem(expirationKey);
      this.modals.appointment.open();
    }

    $$tracker.clickDownload();
  }

  /**
   * 点击播放pv按钮
   */
  // onClickPlayVideo = () => {
  //   if (!this.videoPvId) {
  //     AntdMessage.info(`${getLocales('global.comming_soon')}!`);
  //     return false;
  //   }
  //   console.log(this.videoPvId);
  //   Video.append({
  //     videoId: this.videoPvId,
  //     // videoId: 'F2aCr4RP_dA',
  //     modalContainerClassName: styles.modalContainer,
  //     closeCb: () => {
  //       console.log('关闭pv视频');
  //       // this.onPvVideoClose();
  //     }
  //   });
  // };

  /**
   * 点击打开视频弹窗
   */
  @autobind
  openVideoModal() {
    this.videoModal.open({ extraProps: { store: this.videoModalStore } });
  }

  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  getCmsConfigAsync = () => {
    return cmsApi.makeCmsCustomConfigRequest(CMS_API_CONFIG_ROOT, `zt/${getLanguageFolderName()}_mechabreak_index_config`);
  };

  getNewsListAndVideoUrlAsync = async () => {
    return await cmsApi
      .makeCmsCustomConfigRequest('//www.mechabreak.com/api/config/tag/', 'zt/mechabreak_pre_dlc_20241205')
      .then(res => {
        // console.log(res);
        let currentLanguage = getLanguageByPath();
        if (currentLanguage === 'zh-Hant') {
          currentLanguage = 'zh_HK';
        }
        this.videoModalStore.videoUrl = res['video_url_' + currentLanguage];
      })
      .catch(e => {
        console.log(e);
      });
  };

  use() {
    this.modals = {
      appointment: useModal(AppointmentModal, { store: this.appointmentModalStore }),
      AppointmentSuccess: useModal(AppointmentSuccessModal, { store: this.appointmentSuccessModalStore })
    };
    this.videoModal = useModal(VideoModal);

    this.getCmsConfig = useRequest(this.getCmsConfigAsync, {
      onSuccess: data => {
        this.appointmentSuccessModalStore.twitterLink = data.twitter_link;
        this.appointmentSuccessModalStore.discordLink = data.discord_link;
        this.appointmentSuccessModalStore.youtubeLink = data.youtube_link;
      },
      onError: e => {
        throw new Error('request has error' + e.message);
      }
    });

    useMount(() => {
      // TODO
      this.newsSwiperStore.init();
      this.getNewsListAndVideoUrlAsync();
      // this.modals.appointment.open();
      // this.modals.AppointmentSuccess.open();
    });
  }
}

export default FirstSectionStore;
